import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Star } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const MovieCard = ({ movie }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/movie/${movie.id}`);
  };

  return (
    <Card
      className="movie-card relative overflow-hidden bg-black/40 border border-white/10 cursor-pointer group"
      onClick={handleClick}
      data-testid={`movie-card-${movie.id}`}
    >
      <CardContent className="p-0">
        <div className="relative aspect-[2/3] overflow-hidden">
          {movie.poster_path ? (
            <img
              src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
              alt={movie.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            />
          ) : (
            <div className="w-full h-full bg-gray-800 flex items-center justify-center">
              <span className="text-gray-500">No Image</span>
            </div>
          )}

          {/* Hover Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
            <div className="flex items-center gap-2 mb-2">
              <Star className="w-4 h-4 text-cinema-gold fill-cinema-gold" />
              <span className="text-white font-semibold">
                {movie.vote_average?.toFixed(1)}
              </span>
            </div>
            <h3 className="text-white font-semibold text-base mb-2 line-clamp-2">
              {movie.title}
            </h3>
            <div className="flex items-center gap-2">
              <Play className="w-4 h-4 text-[#7FFF7F] fill-[#7FFF7F]" />
              <span className="text-sm text-gray-300">
                {movie.release_date?.split('-')[0] || 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default MovieCard;